import { render } from "./App.vue?vue&type=template&id=c4b7f9ae"
const script = {}

import "./App.vue?vue&type=style&index=0&id=c4b7f9ae&lang=css"

import exportComponent from "/home/n3rdy/dev/virtuallab-networksecurity/exp-8/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__